import { scrollToReportScrollTarget } from "@/lib/template-studio/reportScrollTarget";
import { cn } from "@/lib/utils";

export interface ReportTableOfContentsEntry {
  elementId: string;
  title: string;
}

export interface ReportTableOfContentsProps {
  sections: ReportTableOfContentsEntry[];
  className?: string;
}

const formatOrderLabel = (order: number): string =>
  String(order).padStart(2, "0");

/** In-report contents list with links to report section blocks. */
export const ReportTableOfContents = ({
  sections,
  className,
}: ReportTableOfContentsProps) => {
  return (
    <nav
      aria-label="Contents"
      className={cn("flex w-full flex-col gap-2 px-4", className)}
    >
      <p className="text-[11px] font-medium uppercase leading-4 tracking-[0.44px] text-gray-600">
        Contents
      </p>
      {sections.length > 0 ? (
        <ul className="flex flex-col gap-2">
          {sections.map((section, index) => (
            <li key={section.elementId}>
              <button
                type="button"
                className="flex w-full min-w-0 items-end gap-0 text-left"
                onClick={() => scrollToReportScrollTarget(section.elementId)}
              >
                <span className="w-6 shrink-0 text-[11px] font-normal uppercase leading-4 tracking-[0.44px] text-slate-500">
                  {formatOrderLabel(index + 1)}
                </span>
                <span className="min-w-0 wrap-break-word pl-0 text-xs font-medium leading-4 text-gray-700">
                  {section.title}
                </span>
                <span
                  aria-hidden
                  className="mb-1 ml-3 min-h-px min-w-8 flex-1 border-b border-dashed border-slate-200"
                />
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </nav>
  );
};
